<template>
  <el-dialog
    :visible.sync="show"
    :width="width"
    :close-on-click-modal="false"
    @closed="onCloseDialog"
  >
    <h2 class="text__center">
      Create a Credit Note
    </h2>

    <el-form
      id="credit_note_form"
      ref="form"
      :model="form"
      label-width="120px"
    >
      <el-form-item label="Invoice Number">
        <el-select
          v-model="form.invoice_id"
          placeholder="Select Invoice"
          class="invoice__select"
          @change="onInvoiceChanged"
        >
          <el-option
            v-for="invoice in invoices"
            :key="invoice.id"
            :label="`4000${invoice.id}  -  ${invoice.job_name}`"
            :value="invoice.id"
          >
            <span style="float: left">4000{{ invoice.id }}</span>
            <span style="float: right">{{ invoice.job_name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Amount">
        <el-input v-model="form.amount" />
      </el-form-item>
      <el-form-item label="Total Price">
        <Money :amount="-total_price" />
        <span>(GST included)</span>
      </el-form-item>
      <el-form-item label="Date">
        <el-date-picker
          v-model="form.invoice_date"
          type="date"
          placeholder="Pick a day"
          format="dd/MM/yyyy"
        />
      </el-form-item>
      <el-form-item label="Description">
        <div class="description_editor">
          <jodit-editor
            v-model="form.description"
            :buttons="buttons"
            :config="jodit_config"
          />
        </div>
      </el-form-item>
    </el-form>
    <div
      v-if="error_message"
      class="error"
    >
      {{ error_message }}
    </div>
    <span
      slot="footer"
    >
      <el-button
        type="info"
        @click="close_dialog"
      >
        Close
      </el-button>
      <el-button
        type="primary"
        @click="onCreate"
      >
        Create
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {createCreditNotes} from '../../../../api/credit_notes';
import CommonJoditMixin from '../../../../mixins/CommonJoditMixin';
import {EventBus} from '../../../../utilities/EventBus';
import Money from '../../../shared/Money';
import {loadInvoiceDetails, loadInvoiceOpen} from '../../../../api/invoice';
import {dateString} from '../../../../utilities/Date';

export default {
  name: 'CreditNotesDialog',
  components: {Money},
  mixins: [CommonJoditMixin],
  props: {
    show_cn_dialog: {
      type: Boolean,
      required: true
    },
    account_id: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      show: this.show_cn_dialog,
      width: '70%',
      media_query_sm: window.matchMedia('(min-width: 1000px)'),

      form: {
        invoice_id: '',
        description: '',
        amount: '',
        invoice_date: ''
      },
      error_message: '',
      invoices: []
    };
  },
  computed: {
    total_price() {
      let amount = this.form.amount ? parseFloat(this.form.amount) : 0;
      return (amount + amount * 0.15).toFixed(3);
    }
  },
  created() {
    this.change_width();
    this.media_query_sm.addEventListener('change', () => {
      this.change_width();
    });
    loadInvoiceOpen(this, this.account_id).then(({data})=>{ this.invoices = data; });
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.querySelectorAll('#credit_note_form .el-input__inner')).forEach(
        function(e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    });
  },
  methods: {
    onCloseDialog() {
      this.$emit('update:show_cn_dialog', false);
    },
    onCreate() {
      this.error_message = '';
      createCreditNotes(
        this,
        this.form.invoice_id,
        this.form.amount,
        dateString(this.form.invoice_date),
        this.form.description
      ).then(({data})=>{
        this.$message({
          type: 'success',
          message: data.message
        });
        EventBus.$emit('refreshAllInvoice');
        this.close_dialog();
      }).catch(({data})=>{ this.error_message = data.details; });

    },
    onInvoiceChanged() {
      loadInvoiceDetails(this, this.form.invoice_id)
        .then(({data})=>{
          this.form.amount = data.amount;
          this.form.description = data.description;
          this.form.invoice_date = new Date(data.invoice_date);
        });
    },
    close_dialog() {
      this.show = false;
    },
    change_width() {
      if(this.media_query_sm.matches) {
        this.width = '70%';
      } else {
        this.width = '90%';
      }
    },
  }
};
</script>

<style lang='scss' scoped>
.dash-line {
  border-bottom:1px dashed #000;
  float: left;
  width:100%;
  margin-top:10px;
  margin-bottom:10px
}

.result-total {
  font-weight:bold;
  font-size:16px;
}

.el-form-item {
  margin-bottom: 22px !important;
}

.error {
  color: red;
}

.invoice__select {
  width: 100%;
}
</style>
